// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"884c45d4","107":"d45509ba","434":"68c4d328","474":"79aa89d7","658":"1387f5e6","683":"c8e7398d","967":"817beddf","990":"ec503e7b"}[chunkId] + ".chunk.js";
};